// @ts-check

/**
 * CUSTOM: Regel "kun én linje" (12/10 2026) – fx OBS-teksten under navnefeltet og produktionstiden under Læg i kurv.
 * Elementer med data-custom-one-line får white-space: nowrap (i featurens egen CSS). Her gøres skriften lige så
 * meget mindre, at teksten passer i bredden (ejers valg):
 *   1. Passer den allerede → skriftstørrelsen fra CSS/editoren bruges uændret.
 *   2. Normalt mindskes den højst til 11px (mindste trin i brandets skala, assets/custom-typography.css).
 *   3. Kun på meget smalle skærme (ca. under 340–350px) må den gå ned til 10px for at blive på én linje.
 *   4. Passer den heller ikke ved 10px → to lige lange linjer i 11px (text-wrap: balance).
 * Teksten afkortes ALDRIG med "…" – kunden skal altid kunne læse hele beskeden.
 * Bruges af: snippets/custom-name-personalization, snippets/custom-product-info-blocks
 * Ren logik i CustomOneLine.decide() – kan testes isoleret.
 */
(function () {
  /** @type {any} */
  const win = window;
  if (win.CustomOneLine) return;

  const NORMAL_MIN = 11; // brandets mindste trin
  const SMALL_MIN = 10; // kun på meget smalle skærme

  /**
   * Ren logik: skriftstørrelse og om teksten skal deles i to linjer.
   * @param {number} base skriftstørrelse fra CSS (px)
   * @param {number} textWidth tekstens bredde på én linje ved base (px)
   * @param {number} available ledig bredde (px)
   * @returns {{ size: number, wrap: boolean }}
   */
  function decide(base, textWidth, available) {
    if (textWidth <= 0 || textWidth <= available) return { size: base, wrap: false };
    const needed = Math.floor(((base * available) / textWidth) * 10) / 10;
    if (needed >= SMALL_MIN) return { size: Math.min(base, needed), wrap: false };
    return { size: Math.min(base, NORMAL_MIN), wrap: true };
  }

  /** @param {HTMLElement} el */
  function wrap(el) {
    el.style.fontSize = Math.min(parseFloat(getComputedStyle(el).fontSize), NORMAL_MIN) + 'px';
    el.style.whiteSpace = 'normal';
    el.style.setProperty('text-wrap', 'balance');
  }

  /** @param {HTMLElement} el */
  function fit(el) {
    el.style.fontSize = '';
    el.style.whiteSpace = '';
    el.style.removeProperty('text-wrap');
    if (el.scrollWidth <= el.clientWidth) return; // passer allerede

    const style = getComputedStyle(el);
    const base = parseFloat(style.fontSize);
    const padding = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
    const available = el.clientWidth - padding;
    const textWidth = el.scrollWidth - padding;
    if (available <= 0) return;

    // 2px sikkerhedsmargin: tekstbredde skalerer ikke helt lineært (afrunding af bogstavbredder)
    const result = decide(base, textWidth, available - 2);
    if (result.wrap) return wrap(el);

    let size = result.size;
    el.style.fontSize = size + 'px';
    // Efterkontrol: stadig for bred → 0,2px ad gangen, aldrig under 10px
    for (let i = 0; i < 10 && el.scrollWidth > el.clientWidth && size > SMALL_MIN; i++) {
      size = Math.max(SMALL_MIN, Math.round((size - 0.2) * 10) / 10);
      el.style.fontSize = size + 'px';
    }
    if (el.scrollWidth > el.clientWidth) wrap(el);
  }

  function fitAll() {
    document.querySelectorAll('[data-custom-one-line]').forEach((el) => fit(/** @type {HTMLElement} */ (el)));
  }

  /** @type {number | undefined} */
  let frame;
  const schedule = () => {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(fitAll);
  };

  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(schedule);
    document.querySelectorAll('[data-custom-one-line]').forEach((el) => observer.observe(el));
  }
  window.addEventListener('resize', schedule, { passive: true });
  // Skrifttypen kan ændre tekstens bredde, når den er indlæst
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  fitAll();

  win.CustomOneLine = { decide, fitAll };
})();
